import React from 'react';

const AboutUs = () => {
  return (
    <div className="page">
      <h1 className="page-title">About Us</h1>
      
      <div className="card">
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>Legal Entity Information</h2>
          <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>
            CalorieNSweat is a proprietary technology platform developed, owned, and operated by <strong>Mind Yards Solutions Private Limited</strong>, a company incorporated under the Companies Act, 2013, Government of India.
          </p>
          <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>
            Mind Yards Solutions Private Limited is engaged in the business of developing and providing technology solutions, SaaS platforms, and digital infrastructure services.
          </p>
          <p style={{ lineHeight: '1.6' }}>
            All platform operations, subscription billing, customer support, compliance, and payment processing are managed directly by Mind Yards Solutions Private Limited.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>Platform Overview</h2>
          <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>
            CalorieNSweat is an AI-enabled Software-as-a-Service (SaaS) platform designed to support independent health coaches and wellness associates in managing their client relationships and operational workflows efficiently.
          </p>
          <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>
            The platform provides structured digital tools for:
          </p>
          <ul style={{ marginLeft: '20px', marginBottom: '15px', lineHeight: '1.6' }}>
            <li>Client data management</li>
            <li>Health progress tracking</li>
            <li>Report generation</li>
            <li>Communication management</li>
            <li>Activity and nutrition monitoring</li>
            <li>AI-assisted insights and automation</li>
          </ul>
          <p style={{ lineHeight: '1.6' }}>
            CalorieNSweat operates solely as a technology service provider and does not engage in the sale of physical goods, nutritional products, financial services, or marketplace transactions.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>Subscription & Revenue Model</h2>
          <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>
            CalorieNSweat follows a transparent subscription-based SaaS business model.
          </p>

          <h3 style={{ color: 'var(--dark-blue)', marginBottom: '10px' }}>1. End Customers (Fitness Clients)</h3>
          <ul style={{ marginLeft: '20px', marginBottom: '15px', lineHeight: '1.6' }}>
            <li>No platform subscription fee is charged to end customers.</li>
            <li>Customers access the platform through their respective registered coach or associate.</li>
          </ul>

          <h3 style={{ color: 'var(--dark-blue)', marginBottom: '10px' }}>2. Coaches / Associates</h3>
          <p style={{ lineHeight: '1.6', marginBottom: '10px' }}>
            Registered health coaches and wellness associates are charged a fixed platform subscription fee of:
          </p>
          <div style={{
            background: 'var(--pale-blue)',
            padding: '15px',
            borderRadius: '8px',
            margin: '15px 0',
            textAlign: 'center',
            border: '2px solid var(--primary-blue)'
          }}>
            <strong style={{ fontSize: '18px', color: 'var(--dark-blue)' }}>
              INR 1,000 per month + applicable GST
            </strong>
          </div>
          <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>
            The subscription grants access to:
          </p>
          <ul style={{ marginLeft: '20px', marginBottom: '15px', lineHeight: '1.6' }}>
            <li>Full platform features</li>
            <li>Data storage and reporting tools</li>
            <li>AI-powered assistance</li>
            <li>Workflow automation tools</li>
          </ul>
          <p style={{ lineHeight: '1.6' }}>
            There are no hidden fees, commission-based deductions, or variable transaction charges beyond the stated subscription amount and applicable taxes.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>Refund & Cancellation Policy</h2>
          <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>
            CalorieNSweat operates on a prepaid subscription model.
          </p>
          <div style={{
            background: '#FED7D7',
            border: '2px solid var(--error)',
            padding: '15px',
            borderRadius: '8px',
            margin: '15px 0'
          }}>
            <p style={{ margin: 0, fontWeight: 'bold', color: '#C53030' }}>
              All subscription fees paid by coaches/associates are <strong>non-refundable</strong> once the payment has been successfully processed.
            </p>
          </div>
          <ul style={{ marginLeft: '20px', marginBottom: '15px', lineHeight: '1.6' }}>
            <li>No refunds will be issued for partial usage, unused subscription periods, or early termination.</li>
            <li>Subscription access remains active for the duration of the paid billing cycle.</li>
            <li>Non-renewal will result in discontinuation of access at the end of the active subscription period.</li>
          </ul>
          <p style={{ lineHeight: '1.6' }}>
            By subscribing to CalorieNSweat, coaches/associates acknowledge and agree to the stated No Refund Policy.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>Nature of Services</h2>
          <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>
            CalorieNSweat provides:
          </p>
          <ul style={{ marginLeft: '20px', marginBottom: '15px', lineHeight: '1.6' }}>
            <li>Digital software services</li>
            <li>Data management tools</li>
            <li>AI-powered analytical assistance</li>
            <li>Subscription-based technology access</li>
          </ul>
          <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>
            The platform:
          </p>
          <ul style={{ marginLeft: '20px', marginBottom: '15px', lineHeight: '1.6' }}>
            <li>Does not provide financial services</li>
            <li>Does not process investment transactions</li>
            <li>Does not act as a marketplace for physical goods</li>
            <li>Does not operate as a payment aggregator</li>
            <li>Does not collect MLM commissions</li>
          </ul>
          <p style={{ lineHeight: '1.6' }}>
            Payments collected via authorized payment gateway partners represent subscription fees for access to software services only.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>Compliance & Governance</h2>
          <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>
            Mind Yards Solutions Private Limited ensures:
          </p>
          <ul style={{ marginLeft: '20px', marginBottom: '15px', lineHeight: '1.6' }}>
            <li>Compliance with Indian tax regulations including GST</li>
            <li>Secure handling of payment transactions via approved payment gateway partners</li>
            <li>Data protection and confidentiality standards</li>
            <li>Transparent subscription policies</li>
          </ul>
          <p style={{ lineHeight: '1.6' }}>
            All invoices and billing documents are issued in the name of Mind Yards Solutions Private Limited.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', marginBottom: '15px' }}>Corporate Vision</h2>
          <p style={{ lineHeight: '1.6', marginBottom: '15px' }}>
            Our objective is to build a compliant, secure, and scalable technology platform that enables independent health professionals to digitize their operations through AI-driven insights and structured client management tools.
          </p>
          <p style={{ lineHeight: '1.6' }}>
            CalorieNSweat is committed to maintaining high standards of transparency, regulatory compliance, and responsible digital service delivery.
          </p>
        </section>

        <div style={{
          background: 'var(--pale-blue)',
          padding: '20px',
          borderRadius: '8px',
          border: '2px solid var(--primary-blue)',
          textAlign: 'center'
        }}>
          <h3 style={{ color: 'var(--dark-blue)', marginBottom: '15px' }}>
            Contact Information
          </h3>
          <div style={{ fontSize: '16px', lineHeight: '1.6' }}>
            <p><strong>Mind Yards Solutions Private Limited</strong></p>
            <p>📧 Email: info@mindyards.com</p>
            <p>📍 Address: C-1203, Vastu River Nest, Ravet Pune 412101</p>
            <p>📞 Phone: +91-9850341496</p>
            <p style={{ marginTop: '15px' }}>
              <a 
                href="https://www.mindyards.com" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  color: 'var(--primary-blue)',
                  textDecoration: 'none',
                  fontWeight: '500'
                }}
              >
                Visit Mindyards Website →
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
